import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c(VSnackbar,{attrs:{"top":"","centered":"","elevation":"24","color":_vm.colorType,"value":_vm.snackbar},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c(VBtn,_vm._b({attrs:{"color":"pink","text":""},on:{"click":_vm.close}},'v-btn',attrs,false),[_vm._v(" "+_vm._s(_vm.$t('btn.closeBtn'))+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.snackbarText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }